module.exports = __webpack_public_path__ + "img/BR_round.9675376c.png";